/**
 * Reusable mileage-overwrite confirmation popup.
 *
 * Asks «آیا می‌خواهید این مقدار را به عنوان کیلومتر فعلی خودرو ثبت کنید؟»
 * with exactly two options: «بله» (confirm) and «خیر» (cancel).
 * Theme/layout/RTL come from the shared `.ls-pop` styles (LatestServices).
 * Renders nothing when closed so it never traps focus or blocks the form.
 */
function MileageConfirmPopup({
  isOpen,
  pending = false,
  error = "",
  message = "آیا می‌خواهید این مقدار را به عنوان کیلومتر فعلی خودرو ثبت کنید؟",
  onConfirm,
  onCancel,
}) {
  if (!isOpen) return null;

  const handleOverlayClick = () => {
    if (!pending && onCancel) onCancel();
  };

  return (
    <div
      className="ls-pop-overlay"
      onClick={handleOverlayClick}
      role="alertdialog"
      aria-modal="true"
      aria-label="تأیید کیلومتر فعلی خودرو"
      dir="rtl"
    >
      <div
        className="ls-pop ls-pop--narrow"
        dir="rtl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="ls-pop__header">
          <span className="ls-pop__title">تأیید کیلومتر</span>
        </div>
        <div className="ls-pop__body">
          <div className="ls-pop__confirm-text">{message}</div>
          {error && <div className="ls-pop__error">{error}</div>}
        </div>
        <div className="ls-pop__actions">
          <button
            type="button"
            className="completed-card__btn completed-card__btn--save"
            disabled={pending}
            onClick={onConfirm}
          >
            {pending ? "در حال ثبت..." : "بله"}
          </button>
          <button
            type="button"
            className="completed-card__btn completed-card__btn--cancel"
            disabled={pending}
            onClick={onCancel}
          >
            خیر
          </button>
        </div>
      </div>
    </div>
  );
}

export default MileageConfirmPopup;
